import { usePortalStateStore, useTokenStore, useUserStore } from '@/plugins/stores';
import ServiceController from '@/controllers/ServiceController';
import AuthenticationHelper from '@/util/AuthenticationHelper';
import Response from '@/models/Response';
import { AuthResponseStatus } from '@/enums/AuthResponseStatus';
import NotificationMessage from '@/models/NotificationMessage';
import ServiceResponse from '@/models/ServiceResponse';

export default class PageHelper {
  public static async checkLogin() {
    const tokenStore = useTokenStore();
    const serviceResponse = await ServiceController.getServices(tokenStore.accessToken);
    if (serviceResponse.status === AuthResponseStatus.SUCCESS) {
      const userStore = useUserStore();
      userStore.services = (serviceResponse as ServiceResponse).services;
      AuthenticationHelper.setTokens(serviceResponse);
    }
  }

  public static setNotificationMessage(response: Response, persist: boolean = false) {
    const portalStateStore = usePortalStateStore();
    let messageColor: string;
    let messageIcon: string;
    let message: string;
    if (response.status === AuthResponseStatus.SUCCESS) {
      messageColor = 'success';
      messageIcon = '$success';
    } else {
      messageColor = 'error';
      messageIcon = '$error';
    }
    if (localStorage.getItem('polteq-language') === 'nl') {
      message = response.messageNL;
    } else {
      message = response.messageEN;
    }
    portalStateStore.notificationMessages.unshift(new NotificationMessage(message, messageColor, messageIcon, persist));
  }
}
